import request from "../utils/fetch";

// 销售客户列表
export function staffClientListNew(data) {
  return request({
    url: "/user/sales/user/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 销售客户列表
export function staffClientListNew2(data) {
  return request({
    url: "/user/sales/user/new/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 销售客户水卡列表
export function staffClientCardList(data) {
  return request({
    url: "/user/sales/user/customer/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 客户迁移
export function clientZhuan(data) {
  return request({
    url: "/user/sales/user/migration",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
